// src/components/surveys/questions/QuestionRenderer.tsx
import React from 'react';
import { SurveyQuestion, QuestionType } from '../../../types/survey.types';
import YesNoQuestion from './YesNoQuestion';
import MultipleChoiceQuestion from './MultipleChoiceQuestion';
import MultiSelectQuestion from './MultiSelectQuestion';
import TextQuestion from './TextQuestion';
import RatingScaleQuestion from './RatingScaleQuestion';
import DropdownQuestion from './DropdownQuestion';
import DateQuestion from './DateQuestion';
import NumberQuestion from './NumberQuestion';
import PhoneQuestion from './PhoneQuestion';
import EmailQuestion from './EmailQuestion';

interface QuestionRendererProps {
  question: SurveyQuestion;
  value?: any;
  onChange?: (value: any) => void;
  disabled?: boolean;
  showValidation?: boolean;
  error?: string;
  mode?: 'edit' | 'preview' | 'response';
}

const QuestionRenderer: React.FC<QuestionRendererProps> = ({
  question,
  value,
  onChange,
  disabled = false,
  showValidation = false,
  error,
  mode = 'response',
}) => {
  const commonProps = {
    question,
    value,
    onChange,
    disabled,
    showValidation,
    error,
    mode,
  };

  switch (question.type) {
    case 'yes_no':
      return <YesNoQuestion {...commonProps} />;
    case 'multiple_choice':
      return <MultipleChoiceQuestion {...commonProps} />;
    case 'multi_select':
      return <MultiSelectQuestion {...commonProps} />;
    case 'text':
      return <TextQuestion {...commonProps} />;
    case 'rating_scale':
      return <RatingScaleQuestion {...commonProps} />;
    case 'dropdown':
      return <DropdownQuestion {...commonProps} />;
    case 'date':
      return <DateQuestion {...commonProps} />;
    case 'number':
      return <NumberQuestion {...commonProps} />;
    case 'phone':
      return <PhoneQuestion {...commonProps} />;
    case 'email':
      return <EmailQuestion {...commonProps} />;
    default:
      return (
        <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-yellow-700">
            Unknown question type: {(question as any).type}
          </p>
        </div>
      );
  }
};

export default QuestionRenderer;
